import $ from 'jquery';
import { Maybe, None } from "../../lib/misc/option";
import { LabelLayer } from "../layers/server/LabelLayer";
import { ThematicLayer } from "../layers/server/ThematicLayer";
import { VectorLayer } from '../layers/server/VectorLayer';
export class OverlayLayerBox {
    constructor(opts) {
        this.indices_of_visible_layers = new Map();
        this.layer_group = new Map();
        this.initialized = false;
        this.layers = [];
        this.label_layers = [];
        this._dragging = None.instance();
        this._dragged_over = None.instance();
        this.header = $();
        this.body = $();
        this.render_index = opts.render_index;
        this.ui_index = opts.ui_index;
        this.filter = l => !l.is_base && !(l instanceof ThematicLayer);
    }
    add_layers(layers) {
        this.layers = layers.filter(this.filter);
        this.label_layers = this.layers.filter(l => l instanceof LabelLayer);
        this.create_label_layer_groups(this.label_layers);
        this.label_layers.forEach(l => {
            l.add_visibilty_observer((visible, server_layer) => {
                var _a, _b;
                let layer = server_layer;
                let layer_num = (_b = (_a = layer.default_params.LAYERS) === null || _a === void 0 ? void 0 : _a.split(":").pop()) !== null && _b !== void 0 ? _b : "";
                let index_group = this.indices_of_visible_layers.get(l.url);
                if (visible) {
                    if (!index_group.includes(layer_num)) {
                        index_group.push(layer_num);
                    }
                    this.hide_layers_of_group_except(layer);
                    this.fetch(layer, index_group);
                }
                else {
                    index_group = index_group.filter(x => x !== layer_num);
                    let available_layer = this.get_next_available_layer_of_group(layer, index_group);
                    this.hide_layers_of_group_except(available_layer);
                    this.fetch(available_layer, index_group);
                }
                this.indices_of_visible_layers.set(l.url, index_group);
            });
        });
        this.build_ui();
    }
    set_dragging(e) {
        this._dragging = Maybe(e.data.layer);
    }
    set_dragged_over(e) {
        e.preventDefault();
        this._dragged_over = Maybe(e.data.layer);
        this.layers.forEach(layer => {
            if (!layer.ui.isNone()) {
                const dragged_layer = this._dragged_over.unwrap();
                const ui = layer.ui.unwrap();
                if (layer === dragged_layer) {
                    ui.children('#placeholder_div').toggle(true);
                }
                else {
                    ui.children('#placeholder_div').toggle(false);
                }
            }
        });
    }
    reorder(_e) {
        if (this._dragging.isNone() || this._dragged_over.isNone())
            return;
        this.layers.forEach(layer => {
            if (!layer.ui.isNone()) {
                const ui = layer.ui.unwrap();
                if (ui) {
                    ui.find('#placeholder_div').toggle(false);
                }
            }
        });
        let priors = this.layers;
        let idx1 = priors.indexOf(this._dragging.unwrap());
        let idx2 = priors.indexOf(this._dragged_over.unwrap());
        let layer1 = this._dragging.unwrap();
        let layer2 = this._dragged_over.unwrap();
        if (layer1 === layer2) {
            return;
        }
        let zs = priors.map(layer => layer.raw.map(l => l.getZIndex()).unwrapOr(0));
        priors.splice(idx1, 1);
        priors.splice(idx2, 0, this._dragging.unwrap());
        priors.forEach((layer, idx) => layer.raw.map(l => l.setZIndex(zs[idx])));
        this.build_ui();
    }
    set_mouse_enter(e) {
        e.preventDefault();
        let hovered_layer = Maybe(e.data.layer);
        const ui = hovered_layer.unwrap().ui.unwrap();
        if (ui) {
            ui.children('span').toggle(true);
        }
    }
    set_mouse_leave(e) {
        e.preventDefault();
        let hovered_layer = Maybe(e.data.layer);
        const ui = hovered_layer.unwrap().ui.unwrap();
        if (ui) {
            ui.children('span').toggle(false);
        }
    }
    build_ui() {
        if (!this.initialized) {
            this.header = $('<div class="header">Overlays</div>');
            this.header.append(this.construct_opacity_select());
            this.header.append($('<hr class="layerbox-hr" /> '));
            this.body = $('<div class="layerType overlay"></div>');
        }
        this.body.children().detach();
        this.layers.forEach(layer => {
            if (layer.ui.isNone()) {
                return;
            }
            const node = layer.ui.unwrapOr($());
            if (node) {
                node.off();
                if (layer instanceof VectorLayer) {
                    let legend_ui = layer.legend_ui;
                    node.append(legend_ui);
                }
                this.body.append(node);
            }
        });
        this.initialized = true;
    }
    construct_opacity_select() {
        const select = $('<select style="float:right; font-weight:normal" name="noname01"></select>');
        const range = Array.from(Array(11).keys()).reverse();
        const default_opacity = 80;
        const options = range.map(value => value * 10).map(value => $(`<option value="${value / 100}" ${value === default_opacity ? "selected" : ""}>${value}</option>`));
        for (let opt of options)
            select.append(opt);
        this.set_layers_opacity(default_opacity / 100);
        select.on('change', (e) => {
            this.set_layers_opacity(parseFloat(e.target.value));
            select.prop('value', e.target.value);
        });
        return select;
    }
    set_layers_opacity(opacity) {
        this.layers.forEach(l => {
            l.opacity = opacity;
        });
    }
    hide_layers_of_group_except(current_layer) {
        let layers = this.layer_group.get(current_layer.url);
        let other_layers = layers.filter(l => l !== current_layer);
        other_layers.forEach(l => {
            l.raw
                .map(l => l.setVisible(false));
        });
    }
    get_next_available_layer_of_group(current_layer, index_group) {
        var _a;
        let layers = (_a = this.layer_group.get(current_layer.url)) === null || _a === void 0 ? void 0 : _a.filter(l => l !== current_layer);
        let layer_index;
        layers.forEach((layer, index) => {
            if (layer.raw.unwrap().getVisible() === true) {
                layer_index = index;
                return;
            }
        });
        if (layer_index) {
            return layers[layer_index];
        }
        if (!layers.length) {
            return current_layer;
        }
        let layer_dsp_param = [...index_group].pop();
        if (layer_dsp_param) {
            let candidate_layer = layers.filter(l => { var _a; return ((_a = l.default_params.LAYERS) === null || _a === void 0 ? void 0 : _a.split(":").pop()) === layer_dsp_param; }).pop();
            return candidate_layer;
        }
        return current_layer;
    }
    create_label_layer_groups(layers) {
        layers.forEach((l, _) => {
            if (this.layer_group.get(l.url)) {
                let group = this.layer_group.get(l.url);
                group.push(l);
                this.layer_group.set(l.url, [...group]);
            }
            else {
                let group = [];
                group.push(l);
                this.layer_group.set(l.url, [...group]);
            }
        });
        this.layer_group.forEach((layers_collection, key) => {
            let idx_array = [];
            layers_collection.forEach(l => {
                var _a, _b;
                if (!l.visible)
                    return;
                let idx = (_b = (_a = l.default_params.LAYERS) === null || _a === void 0 ? void 0 : _a.split(":").pop()) !== null && _b !== void 0 ? _b : "";
                idx_array.push(idx);
            });
            this.indices_of_visible_layers.set(key, [...idx_array]);
        });
    }
    fetch(layer, index_group) {
        layer.raw.map(l => {
            l.setVisible(true);
            let params = { ...layer.default_params, LAYERS: `show:${index_group.join(',')}` };
            let img_src = l.getSource();
            img_src.updateParams(params);
            l.setSource(img_src);
            l.getSource().refresh();
        });
        layer.changed();
    }
}
